<template>
  <v-row no-gutters>
    <v-col cols="2" />
    <v-col cols="9" class="pl-1 text-caption grey--text">
      <div v-for="line in lines">· {{ line }}</div>
    </v-col>
    <v-col cols="1" />
  </v-row>
</template>

<script>
  export default {
    props: {
      notes: {
        required: true,
        type: String,
      },
    },

    computed: {
      lines () {
        return this.notes.split('\n')
      },
    },
  }
</script>
